export default "__VITE_ASSET__D1keO_dY__"